import { render, staticRenderFns } from "./DataTableArray.vue?vue&type=template&id=c3d939cc"
import script from "./DataTableArray.vue?vue&type=script&lang=js"
export * from "./DataTableArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports